import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { CreditCard } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ToastContainer } from '../common/ToastContainer';
import { useSubscription } from '../../features/subscription/hooks/useSubscription';

export const MainLayout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const handleDrawerClose = () => setMobileOpen(false);
  const { data } = useSubscription();
  const subscription = data?.data;

  return (
    <div className="flex min-h-screen">
      {/* スキップリンク */}
      <a
        href="#main-content"
        data-testid="skip-to-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:no-underline focus:ring-2 focus:ring-offset-2 focus:ring-primary focus:outline-none"
      >
        メインコンテンツへスキップ
      </a>

      {/* サイドバー */}
      <Sidebar mobileOpen={mobileOpen} onMobileClose={handleDrawerClose} />

      {/* ヘッダー */}
      <Header onMenuClick={handleDrawerToggle} />
      {subscription?.status === 'past_due' && (
        <div className="fixed top-3.5 right-36 z-50">
          <Link
            to="/subscription"
            data-testid="header-payment-warning"
            className="relative p-2 rounded-lg hover:bg-red-50 transition-colors"
            title="お支払いに問題があります"
          >
            <CreditCard className="h-5 w-5 text-red-500" />
            <span className="absolute -top-1 -right-1 h-3 w-3 bg-red-500 rounded-full" />
          </Link>
        </div>
      )}

      {/* メインコンテンツ */}
      <main
        id="main-content"
        tabIndex={-1}
        data-testid="main-content"
        className="flex-grow min-h-screen min-w-0 overflow-x-hidden bg-bg-secondary"
      >
        {/* ヘッダー高さ分スペーサー */}
        <div className="h-16" />
        <div className="p-4 md:p-6">
          <Outlet />
          <footer
            data-testid="global-footer"
            className="mt-8 pt-6 border-t border-border text-xs text-text-secondary flex flex-wrap items-center gap-4"
          >
            <span>© 2026 EntryBOT</span>
            <a
              data-testid="footer-legal-terms"
              href="https://entry-chat-bot.com/terms"
              target="_blank"
              rel="noreferrer"
              className="hover:text-primary transition-colors"
            >利用規約</a>
            <a
              data-testid="footer-legal-privacy"
              href="https://entry-chat-bot.com/privacy"
              target="_blank"
              rel="noreferrer"
              className="hover:text-primary transition-colors"
            >プライバシーポリシー</a>
            <a
              data-testid="footer-legal-tokushoho"
              href="https://entry-chat-bot.com/legal"
              target="_blank"
              rel="noreferrer"
              className="hover:text-primary transition-colors"
            >特定商取引法に基づく表示</a>
          </footer>
        </div>
      </main>

      {/* トースト通知 */}
      <ToastContainer />
    </div>
  );
};
